import { getCleanPhoneNumber } from 'External/containers/tenant/form/utils/Utils';

const phoneFormatter = (phoneNumber) => {
    const cleansedNumber = getCleanPhoneNumber(phoneNumber);
    return cleansedNumber.replace(/^(\d{1})(\d{3})(\d{3})(\d{4})(\w*)$/, '($2) - $3 - $4 $5');
};

export { phoneFormatter };
